import { MakeCall } from './createMakeCall';
import { ConversationsCounters } from './types/ConversationsCounters';

interface Query {
  listingId?: number;
}

export type CountersResponse = ConversationsCounters;

export default (makeCall: MakeCall) => (userId: number, query?: Query) =>
  makeCall<CountersResponse>(
    'GET',
    `/api/v2/conversations/counters/user/${userId}`,
    { query },
  );
